export const BORDERS_HEIGHT_COMPENSATION_PIXELS = 2;
